import React from 'react';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import BoltIcon from '@mui/icons-material/Bolt';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { HelpGuideTabEnum } from './interfaces';

export const HELP_GUIDE_MONO_FONT =
  "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

export const HELP_GUIDE_TABS = [
  {
    id: HelpGuideTabEnum.CONTROLS,
    labelKey: 'helpGuide.tabs.controls',
    icon: <KeyboardIcon />,
  },
  {
    id: HelpGuideTabEnum.HOTKEYS,
    labelKey: 'helpGuide.tabs.hotkeys',
    icon: <BoltIcon />,
  },
  {
    id: HelpGuideTabEnum.POINTS_OF_INTEREST,
    labelKey: 'helpGuide.tabs.pointsOfInterest',
    icon: <PlaceOutlinedIcon />,
  },
  {
    id: HelpGuideTabEnum.ASSISTANCE,
    labelKey: 'helpGuide.tabs.assistance',
    icon: <HelpOutlineIcon />,
  },
];

export const HOTKEY_GROUPS = [
  {
    labelKey: 'helpGuide.hotkeysActions',
    binds: [
      { key: 'Space', labelKey: 'helpGuide.binds.jump' },
      { key: 'Shift', labelKey: 'helpGuide.binds.sprint' },
      { key: 'T', labelKey: 'helpGuide.binds.teleport' },
      { key: 'M', labelKey: 'helpGuide.binds.map' },
      { key: 'C', labelKey: 'helpGuide.binds.cameraView' },
      { key: 'Q', labelKey: 'helpGuide.binds.raiseHand' },
      { key: 'P', labelKey: 'helpGuide.binds.laser' },
      { key: 'Z', labelKey: 'helpGuide.binds.scooter' },
    ],
  },
  {
    labelKey: 'helpGuide.hotkeysEmotes',
    binds: [
      { key: 'H', labelKey: 'helpGuide.binds.spreadLove' },
      { key: 'J', labelKey: 'helpGuide.binds.dance' },
      { key: 'B', labelKey: 'helpGuide.binds.bow' },
      { key: 'Y', labelKey: 'helpGuide.binds.yes' },
      { key: 'N', labelKey: 'helpGuide.binds.no' },
      { key: '1', labelKey: 'helpGuide.binds.wave' },
      { key: '2', labelKey: 'helpGuide.binds.applaud' },
      { key: '3', labelKey: 'helpGuide.binds.celebrate' },
      { key: '6', labelKey: 'helpGuide.binds.shakeHead' },
      { key: '7', labelKey: 'helpGuide.binds.showOff' },
      { key: '8', labelKey: 'helpGuide.binds.laugh' },
      { key: '9', labelKey: 'helpGuide.binds.thumbsUp' },
      { key: '0', labelKey: 'helpGuide.binds.thumbsDown' },
    ],
  },
];
